//Vercel Api
export const Base_Url = "https://prod-api.jobmongo.mkisan.com/api";
export const Node_UploadExcel_Url = `https://node-js-multipurpose-api.vercel.app`;
export const generatePdf_Url = `https://heuristic-perlman.101-53-133-129.plesk.page`;

// export const Base_Url = 'https://adoring-yalow.184-168-124-42.plesk.page/api';

// export const Base_Url = "https://nifty-herschel.184-168-123-97.plesk.page/api"
// pragatigruhudyogapi.mkisan.com
